import PubSub from "underpub-js";
import OverlayScrollBars from "overlayscrollbars/js/jquery.overlayScrollbars.js";
import gsap from 'gsap';

var NavOverlay = function(options){

	this.options = {
		$el: false,
		baseClass: 'comp-NavOverlay',
	};

	$.extend(true, this.options, options);

};

NavOverlay.prototype.init = function(){

	var self = this;

	this.$primaryNavItems = self.options.$el.find(`.${self.options.baseClass}__navigations .atom-NavigationPrimary li`)
	this.$secondaryNavItems = self.options.$el.find(`.${self.options.baseClass}__secondaryNavigation .${self.options.baseClass}__navItem`)
	this.$closeXSpans = self.options.$el.find(`.${self.options.baseClass}__closeX span`)

	PubSub.subscribe('NavOverlay:show', function() {
	    
		self.show();

	});

	this.options.$el.find(`.${self.options.baseClass}__closeX`).on('click', function() {

		self.hide();

	});

	// overlay scroll bars
	self.overlayScrollbarsInstance = this.options.$el.overlayScrollbars({
		className: "os-theme-dark"
	}).overlayScrollbars();

	this.initAnimationTimelines();

};

NavOverlay.prototype.initAnimationTimelines = function(){

	var self = this;

	this.navInTimeline = gsap.timeline(
		{
			paused: true
		}
	)
	// show nav
	.set(self.options.$el,
		{
			visibility: 'visible',
			zIndex: 2001
		}
	)
	.add(function() {
		self.overlayScrollbarsInstance.scroll([ 0, 0 ]);
	})
	.to(self.options.$el,
		{
			duration: 0.45,
			ease: "power1.out",
			opacity: 1,
			//ease: "power1.out",
		}
	)
	// nav primary links
	.set(self.$primaryNavItems,
		{
			visibility: 'visible',
		},
		">-0.05"
	)
	.to(self.$primaryNavItems,
		{
			duration: 0.45,
			ease: "power1.out",
			opacity: 1,
			y: 0,
			stagger: 0.08
			//ease: "power1.out",
		},
		">-0.05"
	)
	.addLabel("primaryNavIn", ">-0.37")
	// nav secondary links
	.set(self.$secondaryNavItems,
		{
			visibility: 'visible',
		},
		"primaryNavIn"
	)
	.to(self.$secondaryNavItems,
		{
			duration: 0.45,
			ease: "power1.out",
			opacity: 1,
			y: 0,
			stagger: 0.08
			//ease: "power1.out",
		},
		"primaryNavIn"
	)
	.addLabel("secondaryNavIn", ">-0.37")
	// close x
	.from(self.$closeXSpans,
		{
			duration: 0.25,
			width: 0,
			ease: "power3.out"
		},
		"secondaryNavIn"
	)
	.from(self.$closeXSpans,
		{
			duration: 0.25,
			rotate: 0,
			ease: "power1.inOut"
		},
		">-0.1"
	)
	;

	this.navOutTimeline = gsap.timeline(
		{
			paused: true
		}
	)
	.to(self.$closeXSpans,
		{
			duration: 0.25,
			rotate: 0,
			ease: "power1.inOut"
		}
	)
	.to(self.$closeXSpans,
		{
			duration: 0.25,
			width: 0,
			ease: "power3.in"
		},
		">-0.1"
	)
	.to(self.options.$el,
		{
			duration: 0.45,
			ease: "power1.out",
			opacity: 0,
		},
		">-0.1"
	)
	.set(self.options.$el,
		{
			visibility: 'hidden',
			zIndex: -1,
		}
	)
	.call(function() {
		PubSub.publish('NavBar:showHamburger');
	}, null, ">");
	;

};

NavOverlay.prototype.show = function(){

	var self = this;

	this.navInTimeline.restart();

};

NavOverlay.prototype.hide = function(){

	var self = this;

	this.navOutTimeline.restart();

};

export default NavOverlay;
